import { httpApi } from '@api/http.api.ts';
import { CONTENT_TYPE_FORM_DATA_HEADER, NO_REQUEST_TIMEOUT } from '@constants/api.ts';
import { getPercentage } from '@utils/numbers.ts';

const UPLOAD_CONTENT_PUBLIC_URL = '/learning-pathway/upload-content-public';
const UPLOAD_CONTENT_PRIVATE_URL = '/learning-pathway/upload-content';

export interface UploadContentResponse {
    contentId: string;
    bucket: string | null;
    contentType: string;
    fileName: string;
    outputUrl: string;
    isPublic: boolean;
    objectSize: number;
    providerType: string;
}

export const createApiPublicResourceWithUploadProgress = (
    formData: FormData,
    onUploadProgress?: (progress: number) => void,
    signal?: AbortSignal,
): Promise<UploadContentResponse[]> =>
    httpApi
        .post(UPLOAD_CONTENT_PUBLIC_URL, formData, {
            headers: CONTENT_TYPE_FORM_DATA_HEADER,
            signal,
            timeout: NO_REQUEST_TIMEOUT,
            onUploadProgress: (event) => {
                if (!event.total) return;
                onUploadProgress?.(getPercentage(event.loaded, event.total));
            },
        })
        .then(({ data }) => data);

export const createApiResourceWithUploadProgress = (
    formData: FormData,
    onUploadProgress?: (progress: number) => void,
    signal?: AbortSignal,
): Promise<UploadContentResponse[]> =>
    httpApi
        .post(UPLOAD_CONTENT_PRIVATE_URL, formData, {
            headers: CONTENT_TYPE_FORM_DATA_HEADER,
            signal,
            timeout: NO_REQUEST_TIMEOUT,
            onUploadProgress: (event) => {
                if (!event.total) return;
                onUploadProgress?.(getPercentage(event.loaded, event.total));
            },
        })
        .then(({ data }) => data);
